import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mailbox",
  "use": "mailbox-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 13\" id=\"mailbox\">\n  <path fill-rule=\"evenodd\" d=\"M384,151a1,1,0,0,0-1,1v11a1,1,0,0,0,1,1h14a1,1,0,0,0,1-1V152a1,1,0,0,0-1-1H384Zm13.5,1.5v0.393l-6.5,5.454-6.5-5.454V152.5h13Zm-13,10v-7.649l5.857,4.914a1,1,0,0,0,1.286,0l5.857-4.914V162.5h-13Z\" transform=\"translate(-383 -151)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/mailbox.svg
// module id = null
// module chunks = 